module.exports = __webpack_public_path__ + "img/p2-86.afb409b0.png";